/* eslint-disable camelcase */
import { CONFIGS } from "../configs";
import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getDevicePacks = (query) => {
  var {
    currentPage = 1,
    itemsPerPage = 20,
    sortBy = 'created_at',
    sortOrder = -1,
    search = '',
    ...filterParams
  } = query;

  console.log("[Debug] TKT1 Device Pack query", query);

  const page = parseInt(currentPage) || 1;
  const limit = parseInt(itemsPerPage) || 20;
  const skip = (page - 1) * limit;

  let sort = {};
  const order = parseInt(sortOrder) || -1;
  sort[sortBy] = order;

  let queryString = `currentPage=${page}&itemsPerPage=${limit}&sortBy=${sortBy}&sortOrder=${order}`;

  if (search && search.trim()) {
    queryString += `&search=${encodeURIComponent(search.trim())}`;
  }

  // Add other filter parameters
  Object.keys(filterParams).forEach(key => {
    const value = filterParams[key];
    if (value !== undefined && value !== null && value !== '') {
      queryString += `&${key}=${encodeURIComponent(value)}`;
    }
  });

  return API.get(`${getApiUrl()}/api/tkt1-device-pack/?${queryString}`);
};

export const getDevicePackByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-device-pack/${id}`);
};

export const getDevicePackBySN = (sn) => {
  return API.get(`${getApiUrl()}/api/tkt1-device-pack/sn/${sn}`);
};

export const getDevicePackByNetworkSN = (networkSN) => {
  return API.get(`${getApiUrl()}/api/tkt1-device-pack/network-sn/${networkSN}`);
};

export const getDevicePackByPCSN = (pcSN) => {
  return API.get(`${getApiUrl()}/api/tkt1-device-pack/pc-sn/${pcSN}`);
};

export const createDevicePack = (devicePackData) => {
  return API.post(`${getApiUrl()}/api/tkt1-device-pack/`, devicePackData);
};

export const updateDevicePack = (id, devicePackData) => {
  return API.put(`${getApiUrl()}/api/tkt1-device-pack/${id}`, devicePackData);
};

export const updateDevicePackBySN = (sn, devicePackData) => {
  return API.put(`${getApiUrl()}/api/tkt1-device-pack/sn/${sn}`, devicePackData);
};

export const deleteDevicePack = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-device-pack/${id}`);
};

export const tkt1DevicePackService = {
  getDevicePacks,
  getDevicePackByID,
  getDevicePackBySN,
  getDevicePackByNetworkSN,
  getDevicePackByPCSN,
  createDevicePack,
  updateDevicePack,
  updateDevicePackBySN,
  deleteDevicePack
};
